<template>
  <div :class="classes" v-loading="loading">
    <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
    <pt-page-title title="基因检测套餐详情"></pt-page-title>
    <!-- 检测项信息 -->
    <div v-if="detectionPackage" class="content">
      <pt-sub-title title="检测套餐信息"></pt-sub-title>
      <pt-form-item class="special" label="套餐名称:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{detectionPackage.name}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="实验室检测平台:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{detectionPackage.productBean.name}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="报告分析计算:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{formatPackageProductType(detectionPackage.packageProductionType)}}</span>
      </pt-form-item>
      <template v-if="detectionPackage.packageProductionType !== 'THIRDPARTY'">
        <pt-form-item class="special" label="是否基础套餐:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{detectionPackage.packageType === 'DEFAULT_WHOLE_GENOM' ? '是' : '否'}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="基础套餐:" :labelWidth="labelWidth" :lineHeight="lineHeight" v-if="detectionPackage.packageType !== 'DEFAULT_WHOLE_GENOM'">
        <span>{{detectionPackage.basePackageName}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="套餐结构:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <div class="tree-box">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" class="small-input">
            <el-button slot="append" :icon="icon" @click="handleIconClick"></el-button>
          </el-input>
          <!-- lazy :load="getConfig" -->
          <el-tree v-if="showTree" :data="detectionPackage.items" :props="defaultProps" :filter-node-method="filterNode" ref="tree2"  @node-click="handleNodeClick" :lazy="lazy" :load="lazy ? getConfig :()=>{}">
             <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>
                <el-button class="miniSpe" type="primary" size="mini" v-if="data.corpusName">知识库配置</el-button>
                <el-button class="miniSpe" type="primary" size="mini" @click="showConfig(node,data)" v-if="data.configSuiteName">计算配置</el-button>
              </span>
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
      </pt-form-item>
      <!-- <pt-sub-title title="分册信息"></pt-sub-title>
      <pt-form-item class="special" label="是否分上下册:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{detectionPackage.reportParameters.splitBooks ? '是' : '否'}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="下册起始章节:" :labelWidth="labelWidth" :lineHeight="lineHeight" v-if="hasSplit">
        <span v-for="(val, key, index) in detectionPackage.reportParameters.bookSplittingParameters" :key="index">{{detectionPackage.reportParameters.bookSplittingParameters[key]}}</span>
      </pt-form-item> -->
      </template>

    </div>
    <detection-config-dialog :dialogTitle="dialogTitle" :dialogConfigVisible="showDialog" @update="update" :config="config"></detection-config-dialog>
    <el-button type="primary" @click="goEdit(id)">编辑</el-button>
  </div>
</template>

<script>
// 组件class前缀
import { formatConfigType, formatConfigSex, formatPackageProductType } from 'enumeration/lab-order.js'
import detectionConfigDialog from 'cps/gene-product/selector/detection-config-dialog'
const prefixCls = 'pt-detection-package-detail'

export default {
  name: 'pt-detection-package-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    hasSplit () {
      return this.detectionPackage.reportParameters.bookSplittingParameters && Object.values(this.detectionPackage.reportParameters.bookSplittingParameters).filter(e => e !== '').length
    }
  },
  data () {
    return {
      id: this.$route.params.id,
      labelWidth: '110px',
      lineHeight: '26',
      // 用于绑定的产品数据对象
      detectionPackage: this.$route.params.value ? this.$route.params.value : null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
      defaultProps: {
        children: 'items',
        label: 'name',
        isLeaf: 'leaf'
      },
      filterText: '',
      detectionItemCache: [],
      detectionItemConfigCache: [],
      dialogTitle: '',
      showDialog: false,
      config: {},
      icon: 'el-icon-search',
      lazy: true,
      showTree: true
    }
  },
  components: {
    detectionConfigDialog
  },
  methods: {
    formatConfigType,
    formatConfigSex,
    formatPackageProductType,
    toUpdate () {
      // 将详情数据传递给更新页面
      this.$router.push({ name: 'detection-package-update', params: { id: this.id } })
    },
    // 加载详情数据
    load () {
      this.loading = true
      this.loadFailed = false
      this.$store.dispatch('getDetectionPackage', this.id).then((response) => {
        this.loadFailed = false
        this.loading = false
        this.detectionPackage = response.data
        console.log(' this.detectionPackage', this.detectionPackage)
        this.detectionItemCache = response.data.detectionItemCache
        this.detectionItemConfigCache = response.data.detectionItemConfigCache
        this.changFormat(this.detectionPackage)
        console.log('detectionPackage', this.detectionPackage)
      }).catch((error) => {
        console.log(error)
        this.loading = false
        this.loadFailed = true
        this.$message.error('获取信息失败！')
      })
    },
    filterNode (value, data) {
      if (!value) {
        this.icon = 'el-icon-search'
        return true
      }
      if (data.name.indexOf(value) !== -1) {
        this.icon = 'el-icon-search'
        return data.name.indexOf(value) !== -1
      } else {
        this.icon = 'el-icon-search'
      }
    },
    handleIconClick () {
      if (this.filterText) {
        this.showTree = false
        setTimeout(_ => {
          this.lazy = false
          this.showTree = true
        }, 0)
        setTimeout(_ => {
          if (!this.$refs.tree2.lazy) {
            this.icon = 'el-icon-loading'
            this.$refs.tree2.filter(this.filterText)
          }
        }, 0)
      } else {
        setTimeout(_ => {
          this.showTree = false
          setTimeout(_ => {
            this.lazy = true
            this.showTree = true
          }, 100)
        }, 100)
      }
    },
    async getConfig (node, resolve) {
      /* global _ */
      if (_.isArray(node.data)) {
        return resolve(node.data)
      } else {
        if (node.data.type === 'DETECTION') {
          let detectionRes = await this.$store.dispatch('getDetectionWithCorpusAndConfig', node.data.detectionItemId)
          // console.log('detectionRes', detectionRes)
          let detectionConfigs = detectionRes.data.configs || []
          // console.log('detectionConfigs', detectionConfigs)
          detectionConfigs.forEach(ele => {
            node.data.detectionItemConfigIds.forEach(e => {
              if (ele.id === e) {
                let itemConfig = ele
                itemConfig.name = ele.configSuiteName + ' 芯片类型：' + ele.sequencingTechnology + ' （计算模型：' + this.formatConfigType(ele.type) + '  适用性别：' + this.formatConfigSex(ele.gender) + '  位点数：' + ele.sitesCount + '）'
                itemConfig.click = true
                itemConfig.leaf = true
                itemConfig.items = []
                node.data.items.push(itemConfig)
              }
            })
          })
        }
      }
      return resolve(node.data.items)
    },
    changFormat (fullObj) {
      if (!fullObj.items) {
        return
      }
      fullObj.items.forEach(element => {
        if (element.type === 'DETECTION') {
          element.name = this.getDetection(element.detectionItemId)
          element.items = []
          let corpus = {
            name: element.chineseName || element.name,
            chineseName: element.chineseName,
            corpusName: element.corpusName || element.chineseName || element.name,
            items: [],
            leaf: true
          }
          element.items.push(corpus)
        } else {
          this.changFormat(element)
        }
      })
    },
    getDetection (detectionItemId) {
      for (var i = 0; i < this.detectionItemCache.length; i++) {
        if (this.detectionItemCache[i].id === detectionItemId) {
          return this.detectionItemCache[i].chineseName
        }
      }
    },
    getItemConfig (itemConfigIds) {
      var arr = []
      for (var k = 0; k < itemConfigIds.length; k++) {
        for (var i = 0; i < this.detectionItemConfigCache.length; i++) {
          if (this.detectionItemConfigCache[i].id === itemConfigIds[k]) {
            arr.push(this.detectionItemConfigCache[i])
          }
        }
      }
      return arr
    },
    // async getItemCorpus (id) {
    //   this.$store.dispatch('getDetectionCorpus',id).
    // },
    update (val) {
      this.showDialog = val
      this.config = {}
    },
    handleNodeClick (obj, node, nodeself) {
      if (obj.click) {
        this.showDialog = true
        this.config = obj
        this.dialogTitle = this.getDetection(obj.detectionItemId)
      }
    },
    goEdit (id) {
      this.$router.push({ name: 'detection-package-update', params: { id: id } })
    },
    showConfig (node, data) {
      console.log('node', node)
      console.log('data', data)
    }
  },
  created () {
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    this.id = this.$route.params.id
    if (!this.detectionPackage) {
      this.load()
    }
  }
}
</script>

<style lang="less">
@import '~less/var.less';
.pt-detection-package-detail{
  .content{
    margin-bottom: 20px;
  }
  .special >span{
    color:@mainColor;
  }
  .el-input.small-input{
    max-width: 300px;
    margin-bottom: 20px;
  }
  .tree-box{
    border:1px solid #c6cad4;
    padding:20px 10px;
  }
  .el-button.miniSpe{
    padding:5px 10px;
    min-width: 80px;
    line-height: 8px;
    margin-right: 10px;
  }
}

</style>
